import React from 'react'
import { Spinner } from 'react-spinners-css'

export default function SpinnerComponent () {
  return <Spinner color='#000' />
}
